export function SignalStrength({ value }: { value: number }) {
  return (
    <span className="strength" aria-label={`信号强度 ${value} / 5`} title="相对自身历史的异常程度，不是风险评分">
      {Array.from({ length: 5 }, (_, index) => (
        <i className={index < value ? "is-filled" : ""} key={index} />
      ))}
    </span>
  );
}
